import { render, staticRenderFns } from "./TrainingPlanItemNutrition.vue?vue&type=template&id=60bba3e5&scoped=true&"
import script from "./TrainingPlanItemNutrition.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemNutrition.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingPlanItemNutrition.vue?vue&type=style&index=0&id=60bba3e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bba3e5",
  null
  
)

export default component.exports